// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3VJhy","alertIcon":"ConfirmModal_alertIcon__DA-oh"};